<template>
  <div class="information-section">
    <b-row class="d-flex align-items-center mb-2 mt-1 px-2">
      <b-col>
        <span class="ap-title ap-title__main">{{ $tc('globalLocator.sections.subportionData') }}</span>
      </b-col>
    </b-row>

    <b-row class="px-2 pt-2">
      <b-col cols="12">
        <div class="info-card">
          <b-form-row class="h-100">
            <b-col class="flex-row-center">
              <section-info-col-type
                :label="$tc('globalLocator.labels.technique')"
                :data="subportion.assay"
                col-class="flex-column-center"
              >
                <template #default="{ data }">
                  {{ data.name }}
                </template>
              </section-info-col-type>
            </b-col>
            <b-col class="flex-row-center">
              <section-info-col-type
                :label="$tc('globalLocator.labels.laboratory')"
                :data="subportion.currentLaboratory"
                col-class="flex-column-center"
              >
                <template #default="{ data }">
                  {{ data.labName }}
                </template>
              </section-info-col-type>
            </b-col>
          </b-form-row>
        </div>
      </b-col>
      <b-col class="mt-2">
        <div class="info-card">
          <b-form-row class="h-100">
            <b-col class="flex-row-center">
              <section-info-col-type-date
                :label="$tc('globalLocator.labels.requestDate')"
                :date="subportion.requestDate"
                col-class="flex-column-center"
              />
            </b-col>
            <b-col class="flex-row-center">
              <section-info-col-type-date
                :label="$tc('globalLocator.labels.cutDate')"
                :date="subportion.cutDate"
                col-class="flex-column-center"
              />
            </b-col>
            <b-col class="flex-row-center">
              <section-info-col-type-date
                :label="$tc('globalLocator.labels.stainingDate')"
                :date="subportion.assayEndDate"
                col-class="flex-column-center"
              />
            </b-col>
            <b-col class="flex-row-center">
              <section-info-col-type-date
                :label="$tc('globalLocator.labels.deliveryDate')"
                :date="subportion.deliveryDate"
                col-class="flex-column-center"
              />
            </b-col>
          </b-form-row>
        </div>
      </b-col>
    </b-row>

    <b-row class="mt-4 pt-1 px-2">
      <b-col>
        <section-info-col-type-personnel
          :label="$tc('globalLocator.labels.requester')"
          :personnel="subportion.requesterPersonnel"
        />
      </b-col>
      <b-col>
        <section-info-col-type-personnel
          :label="$tc('globalLocator.labels.cutTechnician')"
          :personnel="subportion.cutterPersonnel"
        />
      </b-col>
      <b-col>
        <section-info-col-type-personnel
          :label="$tc('globalLocator.labels.deliveryTechnician')"
          :personnel="subportion.deliveryResponsiblePersonnel"
        />
      </b-col>
    </b-row>

    <b-row class="px-2 pt-4">
      <b-col
        cols="auto"
        class="d-flex align-items-center"
      >
        <span class="ap-title ap-title__divider">{{ $tc('globalLocator.labels.stainingMachine') }}</span>
      </b-col>
      <b-col>
        <hr>
      </b-col>
    </b-row>

    <b-row class="px-2 mt-1">
      <b-col cols="2">
        <section-info-col-type-date
          :label="$tc('globalLocator.labels.entryDate')"
          :date="subportion.assayStartDate"
        />
      </b-col>
      <b-col cols="2">
        <section-info-col-type-date
          :label="$tc('globalLocator.labels.departureDate')"
          :date="subportion.assayEndDate"
        />
      </b-col>
      <b-col cols="4">
        <section-info-col-type-personnel
          :label="$tc('globalLocator.labels.entryTechnician')"
          :personnel="subportion.assayStartResponsiblePersonnel"
        />
      </b-col>
      <b-col cols="4">
        <section-info-col-type-personnel
          :label="$tc('globalLocator.labels.departureTechnician')"
          :personnel="subportion.assayEndResponsiblePersonnel"
        />
      </b-col>
    </b-row>

    <b-row class="px-2 pt-4">
      <b-col
        cols="auto"
        class="d-flex align-items-center"
      >
        <span class="ap-title ap-title__divider">{{ $tc('globalLocator.labels.assemblyDevice') }}</span>
      </b-col>
      <b-col>
        <hr>
      </b-col>
    </b-row>

    <b-row class="px-2 mt-1">
      <b-col cols="2">
        <section-info-col-type-date
          :label="$tc('globalLocator.labels.entryDate')"
          :date="subportion.assemblyStartDate"
        />
      </b-col>
      <b-col cols="2">
        <section-info-col-type-date
          :label="$tc('globalLocator.labels.departureDate')"
          :date="subportion.assemblyEndDate"
        />
      </b-col>
      <b-col cols="4">
        <section-info-col-type-personnel
          :label="$tc('globalLocator.labels.entryTechnician')"
          :personnel="subportion.assemblyStartResponsiblePersonnel"
        />
      </b-col>
      <b-col cols="4">
        <section-info-col-type-personnel
          :label="$tc('globalLocator.labels.departureTechnician')"
          :personnel="subportion.assemblyEndResponsiblePersonnel"
        />
      </b-col>
    </b-row>

    <b-row class="px-2 pt-4">
      <b-col
        cols="auto"
        class="d-flex align-items-center"
      >
        <span class="ap-title ap-title__divider">{{ $tc('globalLocator.labels.scanner') }}</span>
      </b-col>
      <b-col>
        <hr>
      </b-col>
    </b-row>

    <b-row class="px-2 mt-1">
      <b-col cols="2">
        <section-info-col-type-date
          :label="$tc('globalLocator.labels.entryDate')"
          :date="subportion.scanStartDate"
        />
      </b-col>
      <b-col cols="2">
        <section-info-col-type-date
          :label="$tc('globalLocator.labels.departureDate')"
          :date="subportion.scanEndDate"
        />
      </b-col>
      <b-col cols="4">
        <section-info-col-type-personnel
          :label="$tc('globalLocator.labels.entryTechnician')"
          :personnel="subportion.scanStartResponsiblePersonnel"
        />
      </b-col>
      <b-col cols="4">
        <section-info-col-type-personnel
          :label="$tc('globalLocator.labels.departureTechnician')"
          :personnel="subportion.scanEndResponsiblePersonnel"
        />
      </b-col>
    </b-row>

    <b-row class="px-2 pt-4">
      <b-col>
        <hr>
      </b-col>
    </b-row>

    <b-row class="px-2 mt-1">
      <b-col cols="6">
        <section-info-col-type-date
          :label="$tc('globalLocator.labels.cancellationDate')"
          :date="subportion.supCancelDate"
        />
      </b-col>
      <b-col cols="6">
        <section-info-col-type-personnel
          :label="$tc('globalLocator.labels.cancellationTechnician')"
          :personnel="subportion.cancelResponsiblePersonnel"
        />
      </b-col>
    </b-row>

    <b-row class="px-2 mt-4 mb-3">
      <b-col cols="12">
        <section-info-col-type
          :label="$tc('globalLocator.labels.observations')"
          :data="subportion.notes"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import SectionInfoColType from '@/modules/globalLocatorModule/sections/info/col-types/section-info-col-type.vue'
import SectionInfoColTypeDate from '@/modules/globalLocatorModule/sections/info/col-types/date/section-info-col-type-date.vue'
import SectionInfoColTypePersonnel from '@/modules/globalLocatorModule/sections/info/col-types/personnel/section-info-col-type-personnel.vue'

export default {
    name: 'SubportionInfoSection',
    components: {
        SectionInfoColType,
        SectionInfoColTypeDate,
        SectionInfoColTypePersonnel
    },
    props: {
        subportion: { type: Object, required: true }
    }
}
</script>
